export default {"src":"/_next/static/media/close-black.548a2cdc.svg","height":41,"width":46};